const state = {
    roleList:[],
    optionalTableList:[],
};

const mutations = {
    SET_ROLE_LIST: (state, list) => {
        state.roleList = list;
    },
    SET_OPTIONAL_TABLE_LIST: (state, list) => {
        state.optionalTableList = list;
    },
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
